// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.label_vmjMs {
    color : var( --color-columnLabel, currentColor );
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .value_sIetd {
    color : var( --color-columnValue, currentColor );
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .suffix_YOfxH {
    color : var( --color-columnSuffix, currentColor );
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/table/type/ColumnText.css"],"names":[],"mappings":";AACA;IACI,gDAAgD;IAChD,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;IAChD,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iDAAiD;EACnD","sourcesContent":["\n.label {\n    color : var( --color-columnLabel, currentColor );\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  .value {\n    color : var( --color-columnValue, currentColor );\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  .suffix {\n    color : var( --color-columnSuffix, currentColor );\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_vmjMs`,
	"value": `value_sIetd`,
	"suffix": `suffix_YOfxH`
};
export default ___CSS_LOADER_EXPORT___;
